body {
    font-size: 16px;
    /* Use relative units */
    line-height: 1.5;
    margin: 0;
    padding: 0;
}

.header,
.footer {
    width: 100%;
    box-sizing: border-box;
}

.layout {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.header {
    background-color: #f2f2f2;
}

.headerContainer {
    display: flex;
    justify-content: left;
    align-items: center;
}

.headerTitleContainer {
    display: flex;
    align-items: center;
    margin-left: 8px;
    text-decoration: none;
}

.headerTitle {
    font-family: "Segoe UI";
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 28px;
    display: flex;
    align-items: flex-end;
    color: #242424;
}

.headerIcon {
    height: 32px;
    margin-left: 36px;
}

.shareButtonContainer {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 5px 12px;
    gap: 4px;
    width: 86px;
    height: 32px;
    background: radial-gradient(109.81% 107.82% at 100.1% 90.19%, #0F6CBD 33.63%, #2D87C3 70.31%, #8DDDD8 100%)
        /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */
    ;
    border-radius: 4px;
    flex: none;
    order: 1;
    flex-grow: 0;
    cursor: pointer;
}

.shareButton {
    color: #FFFFFF;
}

.shareButtonText {
    font-family: "Segoe UI";
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #FFFFFF;
}

.urlTextBox {
    font-family: "Segoe UI";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #707070;
    border: 1px solid #D1D1D1;
    border-radius: 4px;
}

.copyButtonContainer {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 5px 12px;
    gap: 4px;
    background: #FFFFFF;
    border: 1px solid #D1D1D1;
    border-radius: 4px;
}

.copyButtonContainer:hover {
    cursor: pointer;
    background: #D1D1D1;
}

.copyButton {
    color: #424242;
}

.copyButtonText {
    font-family: "Segoe UI";
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #242424;
}

.chatEmptyState {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 25px;
}

.chatEmptyStateTitle {
    font-style: normal;
    font-weight: 700;
    font-size: 36px;
    display: flex;
    align-items: flex-end;
    text-align: center;
    line-height: 24px;
    margin-top: 36px;
    margin-bottom: 0px;
}

.chatEmptyStateSubtitle {
    margin-top: 20px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    align-items: flex-end;
    text-align: center;
    letter-spacing: -0.01em;
    color: #616161;
}

.chatIcon {
    height: 62px;
    width: auto;
}

@media screen and (-ms-high-contrast: active),
(forced-colors: active) {

    .shareButtonContainer,
    .headerTitleContainer {
        border: 2px solid WindowText;
    }

}

.workflowBar {
    height: 7px;
    background-color:#2D87C3
}
